import { render, staticRenderFns } from "./Callbacktvi.vue?vue&type=template&id=40bbc71a&"
import script from "./Callbacktvi.vue?vue&type=script&lang=js&"
export * from "./Callbacktvi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports